import { FETCH_SCHEDULE_ITEM, FETCH_SCHEDULE_ITEM_SUCCESS, FETCH_SCHEDULE_ITEM_FAILURE, CLEAR_SCHEDULE_ITEM } from '../actions';

const initialState = {
  scheduleitem: {},
  loading: true,
  err: null,
  haveData: false
};

export const reducer = (state = initialState, action) => {
  switch(action.type) {
    case FETCH_SCHEDULE_ITEM:
      return {
        ...state,
        loading: true,
        err: null,
        haveData: false
      };
    case FETCH_SCHEDULE_ITEM_SUCCESS:
      return {
        ...state,
        loading: false,   
        haveData: true,     
        scheduleitem: action.data
      };
    case FETCH_SCHEDULE_ITEM_FAILURE:
      return {
        ...state,
        loading: false,
        haveData: false,
        err: action.error,
        scheduleitem: {}
      };
    case CLEAR_SCHEDULE_ITEM:
      return initialState;
    default:
      return state;
  }
}